import './home.scss';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import homeActions from '../../../store/actions/home.action';
import { hideFirstViewPreloading } from '../../../shared/services/general/preloading-service';
import { setTitle } from '../../../shared/services/general/general-service';
import BaseEntity from '../../../components/base-entity/base-entity';
import { useConfigApp } from '../../../shared/services/general/app-context';
import { getHomePage } from '../../../shared/services/home/home-service';

function HomePage() {
	const config = useConfigApp();
	const data = useSelector(state => state.homeData);
	const dispatch = useDispatch();

	useEffect(() => {
		if (data.length === 0) {
			getData()
		}
	}, [data, dispatch]);

	const renderPageHeader = () => {
		setTitle(`${config?.title} | مرجع تماشای فیلم و سریال`);
	};

	const getData = () => {
		getHomePage().then(
			(result) => {
				hideFirstViewPreloading();
				let response = result.data;
				if (response.code === 200) {
					let temp_data = response.data;
					temp_data.sort((a, b) => {
						if (a.order < b.order) return -1;
						if (a.order > b.order) return 1;
						return 0;
					});
					dispatch(homeActions(temp_data));
				}
			}
		);
	}

	const renderData = () => {
		return (
			<div>
				{renderPageHeader()}
				<BaseEntity data={data} baseUrl={"home"}/>
			</div>
		);
	};

	return (
		<div className="container" style={{marginBottom: '0'}}>
			{renderData()}
		</div>
	);
}

export default HomePage;
